<template>
	<div>
		<v-layout align-center justify-center class="dataLoading">
			<v-progress-circular
				indeterminate
				color="primary"
				v-show="loadingData"
			/>
		</v-layout>

		<coupon-code-filter
			@submit="submit"
		/>
		<div>TODO: search on coupon code</div>
		<coupon-code-table
			:couponCodeData="tableContents"
		/>
	</div>
</template>
<script>
import axios from 'axios'
import CouponCodeFilter from './couponCodeFilter.vue'
import CouponCodeTable from './couponCodeTable.vue'

export default {
	components: { CouponCodeFilter, CouponCodeTable },
	name: 'CouponCodeReport',
	data() {
		return {
			tableContents: [],
			loadingData: false,
		}
	},
	methods: {
		async submit(filters) {
			this.loadingData = true
			try {
				// eslint-disable-next-line no-undef
				const res = await axios.post(`${config.baseAPIurl}/coupon-code`, filters)
				this.tableContents = res.data
			} catch (err) {
				console.log(err)
			} finally {
				this.loadingData = false
			}
		},
	},
}
</script>

<style scoped>

.dataLoading {
	padding-top: 11px;
}

</style>
